{
  "version": 1,
  "asset_id": "cf901954-3bf0-4abf-909a-f0020429a116",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/cf901954-3bf0-4abf-909a-f0020429a116/manual-api-oficial-whatsapp-crm-svg.pdf",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/cf901954-3bf0-4abf-909a-f0020429a116/manual-api-oficial-whatsapp-crm-svg.pdf",
  "original_filename": "manual-api-oficial-whatsapp-crm-svg.pdf",
  "size": 1734240,
  "content_type": "application/pdf",
  "created_at": "2026-07-14T23:50:26Z"
}
